import { defineStore } from 'pinia'
import { loginApi, meApi, type CurrentUser } from '../api/auth'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    token: localStorage.getItem('lingbao_token') || '',
    user: JSON.parse(localStorage.getItem('lingbao_user') || 'null') as CurrentUser | null
  }),
  getters: {
    isAuthed: (state) => Boolean(state.token),
    permissions: (state) => state.user?.permissions || [],
    can: (state) => {
      return (permission?: string) => {
        if (!permission) return true
        const owned = state.user?.permissions || []
        return owned.includes('*') || owned.includes(permission)
      }
    }
  },
  actions: {
    async login(username: string, password: string) {
      const result = await loginApi({ username, password })
      this.token = result.access_token
      this.user = result.user
      localStorage.setItem('lingbao_token', result.access_token)
      localStorage.setItem('lingbao_user', JSON.stringify(result.user))
    },
    async fetchMe() {
      if (!this.token) return
      this.user = await meApi()
      localStorage.setItem('lingbao_user', JSON.stringify(this.user))
    },
    logout() {
      this.token = ''
      this.user = null
      localStorage.removeItem('lingbao_token')
      localStorage.removeItem('lingbao_user')
    }
  }
})

